import { useMemo } from 'react';
import { useContent, useContentContext } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { Stack, Tooltip } from 'src/core/ui';
import { ClockIcon, IconsFill } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { FormatContentId } from 'src/utils/constants/formatContentId';
import { FormatContentIds } from 'src/utils/constants/formatContentIdDataMap';

export function DataLagIndicator({
  lastRefreshTime,
}: {
  lastRefreshTime: string | null;
}) {
  const unknownText = useContent(ContentId.Unknown);

  const { formattedContentResolver } = useContentContext();

  const minutesRefreshedFromNow = useMemo(() => {
    return lastRefreshTime == null
      ? null
      : (new Date().getTime() - new Date(lastRefreshTime).getTime()) /
          1000 /
          60;
  }, [lastRefreshTime]);

  const displayText = useMemo(() => {
    const minutesRefreshedFromNow =
      lastRefreshTime == null
        ? null
        : (new Date().getTime() - new Date(lastRefreshTime).getTime()) /
          1000 /
          60;

    return formattedContentResolver(
      FormatContentIds[FormatContentId.UpdatedNMinutesAgo].id,
      minutesRefreshedFromNow == null
        ? unknownText
        : minutesRefreshedFromNow.toFixed(0),
      FormatContentIds[FormatContentId.UpdatedNMinutesAgo].defaultValue
    ) as string;
  }, [lastRefreshTime, unknownText, formattedContentResolver]);

  return (
    <Tooltip
      triggerContent={
        <Stack direction="row" gap="s" alignItems="center">
          <ClockIcon fill={IconsFill.textWarning} size={vars.iconSize.l} />
          {minutesRefreshedFromNow != null && (
            <span style={{ color: vars.color.textSecondary }}>
              {minutesRefreshedFromNow.toFixed(0)}m
            </span>
          )}
        </Stack>
      }
      align="center"
    >
      <div
        style={{
          whiteSpace: 'nowrap',
          overflow: 'unset',
          textOverflow: 'unset',
          minWidth: 'fit-content',
        }}
      >
        {displayText}
      </div>
    </Tooltip>
  );
}
